module.exports = __webpack_public_path__ + "img/tarjeta_sola_nueva.762ab8af.png";